import { useMemo } from 'react';
const formatStartTokens = (token, otherInlineStartTokens) => ({
  inlineStartToken: `${token}`,
  otherInlineStartTokens
});
const VALID_SPACES = {
  0: formatStartTokens(0),
  500: formatStartTokens(400),
  // 16px
  1000: formatStartTokens(800),
  // 32px
  1300: formatStartTokens(1100),
  // 40px
  1800: formatStartTokens(1400),
  // 64px
  // no Trellis token for 80px, could do 1300 (64px) + 400 (16px)
  2300: formatStartTokens(1300, [400])
};
export const useReassignmentPaddingTokens = paddingInlineStart => useMemo(() => {
  if (!paddingInlineStart) {
    return {
      inlineStartToken: '0'
    };
  }
  const totalPadding = paddingInlineStart.reduce((acc, token) => acc + token, 0);
  const spaces = VALID_SPACES[totalPadding];
  if (!spaces) {
    return {
      inlineStartToken: '0'
    };
  }
  return spaces;
}, [paddingInlineStart]);